<script>
  import { onMount } from 'svelte';

  import Main from '../../shared/Main.svelte';
  import MediaQuery from "../../shared/components/MediaQuery.svelte";

  import Label from './components/Label.svelte';
  import ArrowCircle from './components/ArrowCircle.svelte';
  import Documents from './components/Documents.svelte';
  import Box from './components/Box.svelte';
  import Boxes from './components/Boxes.svelte';
  // import Joints from './components/Joints.svelte';

  import { stepStore } from './stores.js';
	import StepButton from './components/StepButton.svelte';
  
  export let jsonFile;
  let data = {};

  let breakpoint620 = false;

  $: data_boxes = data.boxes || [];
  // While waiting for data to load, #each will complain, 
  // that it only iterates over array-like objects.
  // Option 1: wrap {#each} in {#if data_boxes}
  // Option 2: provide empty array as default

  $: data_intro = data.intro || '';

  $: data_labels = data.labels || [];

	onMount( async () => {
    const response = await fetch( jsonFile );
    const json = await response.json();

    // add some more box properties
    json.boxes.forEach( (box, i) => {
      box.id = i
      box.elementId = 'box-'+i
      box.visible = false
    });

    steps = json.boxes.length
    data = json
	});

  let steps;

  let step;
  const unsubscribe = stepStore.subscribe(value => {step = value});

  // When creating vars using $:, you can only use them in other variables assigned using $:.
  // https://stackoverflow.com/a/56318461/2619245
  //
  // watch changes in step
  $: on_step_change = step
  // handle changes
  $: on_step_change, updateBoxVisibility()

  function updateBoxVisibility(){
    data_boxes.forEach( box => {
      box.visible = box.id < step
    });

    // trigger reactive update for Joints.targets={data_boxes}
    // https://svelte.dev/tutorial/updating-arrays-and-objects
    data_boxes = data_boxes;
  }
</script>

<MediaQuery query="(min-width: 620px)" let:matches bind:matches={breakpoint620} />

<Main noPadding={true} colorFill={'var(--color-blue-light-5)'} borderWidth={'0px'} overflow={'hidden'} fullHeight={false}>
  <div 
    class="grid"
    class:horizontal={ breakpoint620 }
    >
    <div class="grid__label">
      <Label label={ data_labels[ step <= 5 ? 0 : 1 ]}/>
    </div> <!-- .grid__label -->
    <div class="grid__circle">
      <div class="circle-wrapper">
        <ArrowCircle/>
        <span class="sunburst-container">
          <span class="sunburst" class:show="{ step > 9 }"></span>
        </span>
        <Documents {step} />
      </div>
    </div> <!-- .grid__circle -->
    <div class="grid__boxes">
      {#if step==0}
        <div class="intro">
          <Box 
            headline={data_intro.headline}
            copy={data_intro.copy}
            visible={step == 0 }
            step={1}
          />
        </div>
      {/if}
      <Boxes {data_boxes} {step} {steps} />
    </div> <!-- .grid__boxes -->
    <div class="grid__buttons">
      <div class="button-container">
        <StepButton label="↺" action="reset" min="0"/>
        <StepButton action="dec" min="0"/>
        <span class="step">{step}</span>
        <StepButton action="inc" max="10"/>
      </div>
    </div> <!-- .grid__buttons -->
  </div> <!-- .grid -->
  
  <!-- <Joints targets={data_boxes} step={step}/> -->
</Main>

<style>
  :global(body) {
    overflow-x: auto;
    overflow-y: hidden;

    /* 
      23.11.2020 : limit min width to avoid layout on mobile ( → time and effort held postponed for 'future design')
      768px → iPad Portrait
      678px → iPad Portrait Lernbar 3 column content width
      650px → safe value
    */
    /* min-width: 650px; */
  }


  /* JOINTJS (DEBUG) STYLES */
  :global(.joint-cell circle),
  :global(.joint-cell rect) {
    fill: transparent;
    /* fill: rgba(0,255,255,0.1); */
    stroke: none;
  }
  :global(.joint-cell text[joint-selector="label"]) {
    fill: transparent;
    /* fill: rgba(0,200,200,0.3); */
  }

  .grid {
    display: grid;
    column-gap: 4%;
  }
  .grid.horizontal {
    grid-template-columns: 38% 58%;
  }

  .grid__label {
    margin-bottom: 3em;
  }
  .grid.horizontal .grid__label {
    grid-column: span 2;
  }

  .grid__circle {
    width: 80vw;
    height: 80vw;
    max-width: 20em;
    max-height: 20em;
    position: relative;
    margin: 0 auto; /*h-center*/
  }

  .grid.horizontal .grid__circle {
    width: 37vw;
    height: 37vw;
    padding-left: 3vw;
    margin: auto 0 auto auto; /* align right */
  }

  .grid__boxes {
    position: relative;
    display: grid;
  }
  .grid.horizontal .grid__boxes {
    padding-right: 3vw;
  }

  .grid__buttons {
    margin-top: 1em;
  }
  .grid.horizontal .grid__buttons {
    grid-column: span 2;
  }

  .intro {
    grid-column: 1;
    grid-row: 1;
  }

  .button-container {
    text-align: right;
    width: 100%;
  }

  .step {
    text-align: center;
    font-size: 1.3rem;
    line-height: 3.1rem;
    font-weight: bold;
    display: inline-block;
    height: 3rem;
    width: 2.8rem;
    cursor: default;
  }

  .circle-wrapper {
    position: relative;
  }
/*
  .sunburst-container {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;

    z-index: -2;
    overflow: hidden;
  }
  .sunburst {
    display: block;
    position: absolute;
    width: 100vmin;
    height: 100vmin;

    border-radius: 50%;
    overflow: hidden;

    top: -5%; /* align with arrowcircle * /
    transform: scale(0.2) rotate(0deg);
    opacity:0;
  }
  .sunburst.show {
    animation: sunburst 3s forwards linear;
  }
  @keyframes sunburst{
      0% {transform: scale(0.2) rotate(0deg); opacity:0;}
     10% {                                    opacity:1;}
     50% {transform: scale(2) rotate(100deg);}
     90% {                                    opacity:1;}
    100% {transform: scale(6) rotate(200deg); opacity:0;}
  }
  /* borrowed from https://stackoverflow.com/a/27535143/2619245 * /
  .sunburst::before {
    left: 50%;
    transform: rotate(180deg);
  }
  .sunburst::after, 
  .sunburst::before {
    content: '';
    position: absolute;
    background:
      radial-gradient(circle at 50% 50%, #FFFFFF 5%, transparent 5%),
      linear-gradient( 90deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient( 82deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient( 67deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient( 52deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient( 37deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient( 22deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient(  7deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient( -8deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient(-23deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient(-38deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient(-53deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient(-68deg, transparent 50%, #f3f6f7 50%, #f3f6f7),
      linear-gradient(-83deg, transparent 50%, #FFFFFF 50%, #FFFFFF),
      linear-gradient(-90deg, transparent 50%, #f3f6f7 50%, #f3f6f7);
    background-position: 0% 0%;
    background-size: 200% 100%;
    height: 100%;
    width: 50%;
  }
  */
</style>
